<template>
  <div class="pwd-login">

    <header class="h-font">
      <span @click="handleIsShowCode">
        <img src="@/assets/img/login/code.png" alt="">
      </span>
      <span>Hi，欢迎登录中智薪税云</span>
    </header>

    <el-form v-if="changeForm" class="login-form" status-icon :rules="loginRules" ref="loginForm" :model="loginForm">
      <el-form-item prop="username" class="item-user-password">
        <span slot="label">
          <span class="span-box">
              <img src="@/assets/img/login/icon_user.png" class="label-img-icon" alt="">
            <!-- <i class="el-icon-user" /> -->
              <span> 用户名 </span>
          </span>
        </span>
        <el-input size="medium" @keyup.enter.native="handleLogin" @change="getCus" v-model="loginForm.username" debounce="0" auto-complete="off" :placeholder="$t('logon.iptAccount')">
          <!-- <svg slot="prefix" class="icon" style="margin-top: 9px" aria-hidden="true">
            <use xlink:href="#icon-yonghu"></use>
          </svg> -->
        </el-input>
      </el-form-item>
      <el-form-item prop="password" class="item-user-password">
        <span slot="label">
          <span class="span-box">
              <img src="@/assets/img/login/icon_key.png" class="label-img-icon" alt="">
            <!-- <i class="el-icon-lock" /> -->
              <span> 密码 </span>
          </span>
        </span>
        <el-input size="medium" @keyup.enter.native="handleLogin" :type="passwordType" v-model="loginForm.password" auto-complete="off" :placeholder="$t('logon.iptPassword')">
          <i class="el-icon-view el-input__icon" slot="suffix" @click="showPassword"></i>
          <!-- <svg slot="prefix" class="icon" style="margin-top: 9px" aria-hidden="true">
            <use xlink:href="#icon-mima"></use>
          </svg> -->
        </el-input>
      </el-form-item>
      <el-form-item prop="cus" v-if="cusList.length>1">
        <el-select  v-model="loginForm.cusId" :placeholder="$t('logon.selectCustomer')" v-show="this.cusList.length>0" @change="pickCusId">
          <el-option
            v-for="item in cusList"
            :key="item.uid"
            :label="item.cname"
            :value="item.uid">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item prop="code" style="text-align: left;" class="item-code" v-show="this.loginForm.loginType=='2'">
        <el-input size="medium" @keyup.enter.native="handleLogin" v-model="loginForm.code" auto-complete="off" :placeholder="$t('logon.iptCheckcode')">
          <!-- <svg slot="prefix" class="icon" style="margin-top: 9px;" aria-hidden="true">
            <use xlink:href="#icon-yonghu"></use>
          </svg> -->
        </el-input>
        <el-image :src="codeImg.src" :fit="scale-down" @click="refreshCode"></el-image>
      </el-form-item>
      <el-form-item style="text-align: left;">
        <div style="font-size: 12px;">
          <el-checkbox v-model="checked"></el-checkbox>
          {{$t("logon.agree")}}
          <a class="c-primary" href="https://hrcloud.ciicpt.com.cn/ppolicy.html" target="_blank">{{$t("logon.privacyPolicy")}}</a>
        </div>
      </el-form-item>
      <el-form-item class="login-button-item">
        <el-button type="primary" :loading="loginLoading" size="medium" @click.native.prevent="handleLogin" class="login-submit">{{$t("logon.login")}}</el-button>
      </el-form-item>
      <el-form-item>
        <div class="forgetItem">
          <el-link type="primary" @click="changeLaguages">{{lang}}</el-link>
          <el-row>
            <el-link type="primary" @click="handleResetPwd" style="margin-right:34px">{{$t("logon.forgetPassword"/**忘记密码*/)}}</el-link>
            <el-link type="primary" @click="handleReister">{{$t("logon.register"/**注册*/)}}</el-link>
          </el-row>
        </div>
      </el-form-item>
    </el-form>
    <section class="cui-s-code" v-else>
      <img :src="`data:image/png;base64,${codeImgSrc}`"/>
    </section>
  </div>
</template>

<script>
  import { randomLenNum,guid,encrypt, decrypt, dataToTree } from '@/util/util';
  import hrCommon from '@/api/common/hrcloudCommon';
  import {base64Encode} from '@/util/endecode.js';
  import { getCusList, produceQrCode, wcLogin } from '@/api/user/login';
  import store from '@/store';
  const hrPrefix = '/hrcloud'
  export default {
    name: 'pwdlogin',
    data() {
      const validateCode = (rule, value, callback) => {
        if (this.codeImg.value != value) {
          this.loginForm.code = '';
          this.refreshCode();
          callback(new Error(this.$t('logon.iptTrueCheckcode')));
        } else {
          callback();
        }
      };
      return {
        checked: false,
        lang:'En',
        changeForm:true,
        loginForm: {
          username: '',
          password: '',
          cusId: '',
          branchId: '',
          code: '',
          randomStr: '',
          loginType: '1', // 是否需要验证码，默认第一次登陆时是不需要验证码的，密码输入错误后，需要输入验证码
          codeKey: ''
        },
        codeImg: {
          // src: '/user/code',
          src: '',
          value: '',
          len: 4,
          type: 'image',
        },
        loginLoading: false,
        loginRules: {
          username: [
            { required: true, message: this.$t('logon.iptAccount'), trigger: 'blur' },
          ],
          password: [
            { required: true, message: this.$t('logon.iptPassword'), trigger: 'blur' },
            { min: 6, message: this.$t('logon.iptPasswordLen'), trigger: 'blur' },
          ]
        },
        passwordType: 'password',
        cusList:[],
        codeImgSrc: '', // code base64
      };
    },
    created() {
      // console.log(process.env.VUE_APP_LOCAL_DEVELOPMENT)
      this.refreshCode();
      if(this.loginForm.username!=""){
        this.getCus();
      }
      //语言设置
      var lang = localStorage.getItem('lang');
      if(lang){
        this.lang = (lang==='zh')?'En':'中';
        this.$i18n.locale = lang;
      }
    },
    props: ['loginMethod'],
    methods: {
      //选择客户改变
      pickCusId: function (selVal) {
        this.loginForm.cusId= selVal;
        for(let i=0;i<this.cusList.length;i++){
          if(this.cusList[i].uid==selVal){
            this.loginForm.branchId= this.cusList[i].branchId;
            break;
          }
        }
      },
      changeLaguages () {
        let lang = this.$i18n.locale === 'zh' ? 'en' : 'zh';
        this.$i18n.locale = lang;
        localStorage.setItem('lang',lang);
        this.$store.commit('CHANGE_LANG', lang)
        if(lang==='zh'){
          this.lang = 'En';
        }else{
          this.lang = '中';
        }
        //此处主要是翻译语言
        this.loginRules = {
          username: [
            { required: true, message: this.$t('logon.iptAccount'), trigger: 'blur' },
          ],
          password: [
            { required: true, message: this.$t('logon.iptPassword'), trigger: 'blur' },
            { min: 6, message: this.$t('logon.iptPasswordLen'), trigger: 'blur' },
          ]
        }
      },
      changMethod(){
        this.$emit('update:loginMethod', 'code')
      },
      refreshCode() {
        this.loginForm.code = '';
        this.loginForm.codeKey = guid();
        this.loginForm.randomStr = randomLenNum(this.codeImg.len, true);
        this.codeImg.type == 'text'
          ? (this.codeImg.value = randomLenNum(this.codeImg.len))
          : (this.codeImg.src = `${hrCommon.HRCLOUD_URL}util/getVerifyCodeNew.action?codeKey=`+base64Encode(this.loginForm.codeKey)); //调用人事云接口获取 验证码
      },
      showPassword() {
        this.passwordType == ''
          ? (this.passwordType = 'password')
          : (this.passwordType = '');
      },
      getCus(){
          if(this.loginForm.username===''){
            this.cusList = [];
            return;
          }
        // if (!this.checked) {
        //   this.$message.error( this.$t('logon.agreeMsg'));
        //   return;
        // }
          getCusList(this.loginForm.username).then(res => {
              let resDes= JSON.parse(decrypt(res.data));
              this.loginForm.cusId = "";
              this.cusList = [];
              if(200==resDes.statusCode){
                  let dres = decrypt(resDes.data, '');
                  this.cusList = JSON.parse(dres);
                  if(this.cusList.length>1){
                    return;
                  }else if(this.cusList.length == 1 ){
                    this.loginForm.cusId = this.cusList[0].uid;
                    this.loginForm.branchId = this.cusList[0].branchId;
                  }
              }else{
                  this.loginLoading = false;
                  this.$message.error(resDes.msg);
                  return;
              }
          });
      },
      handleLogin() {
        this.$alert('尊敬用户，您好：\n' +
          '\n' +
          '因系统升级原因，2023年4月30日9:00 至 2023年5月3日24:00，本网站将暂停服务。\n' +
          '给您造成的不便，我们深表歉意。', '系统升级提示', {
          confirmButtonText: '确定',
          callback: action => {
          //当username缓存的有值获取不到cusId时处理：
          if(this.loginForm.username && !this.loginForm.cusId){
          this.getCus();
          setTimeout( ()=> {
            this.validate();
          },500)
          }else{
            this.validate();
          }
      }
      });
      },
      // 校验登录分离公共方法
      validate(){
        this.$refs.loginForm.validate((valid) => {
          if (valid) {
            // console.log(/^\d+$/.test(this.loginForm.username))
            if(/^\d+$/.test(this.loginForm.username)){
              //手机号
              this.loginForm.type = 2
            }else if(this.loginForm.username.indexOf("@") != -1){
              //邮箱
              this.loginForm.type = 3
            }else{
              //用户名
              this.loginForm.type = 1
              this.loginForm.username = this.loginForm.username
            }
            if (!this.checked) {
              this.$message.error( this.$t('logon.agreeMsg'));
              return;
            }
            this.loginLoading = true;
            this.$store.dispatch('LoginByUsername', this.loginForm).then(
              (res) => {
            if(!res.data.success){
              this.loginLoading = false;
              this.$message.error(res.data.msg);
              this.loginRules.code = [
                { required: true, message:this.$t('logon.iptCheckcode'), trigger: 'blur' },
                { min: 4, max: 4, message: this.$t('logon.iptCheckcodeLen'), trigger: 'blur' },
              ];
              this.loginForm.loginType = '2';
              this.refreshCode();
            } else {
              const { isInitPwd, isUpdatePwdTips } = res.data.data;
              if (isUpdatePwdTips) {
                this.$alert('您好，您已长时间未更换密码，为了您的账号安全， 建议您更换密码！', '修改密码提示', {
                    confirmButtonText: '确定',
                    callback: action => {
                      this.redirectPath(res);
                    }
                });
              } else if (isInitPwd) {
                this.$alert('您好，为了您的账号安全，建议您更换初始密码！', '修改密码提示', {
                  confirmButtonText: '确定',
                  callback: action => {
                  this.redirectPath(res);
              }
              });
              } else {
                this.redirectPath(res);
              }
            }
          }
          ).catch(
              (error) => {
              this.loginLoading = false;
            if(error.data && error.data.msg){
              this.$message.error(error.data.msg);
            }
            this.loginRules.code = [
              { required: true, message:this.$t('logon.iptCheckcode'), trigger: 'blur' },
              { min: 4, max: 4, message: this.$t('logon.iptCheckcodeLen'), trigger: 'blur' },
            ];
            this.loginForm.loginType = '2';
            this.refreshCode();
          })
          }
        });
      },
      // 登录成功，跳转页面
      redirectPath(res) {
        let userType = res.data.data.userType;
        let cusSourceType = res.data.data.cusSourceType;//0 老系统 1新系统
        if("10620003"!=userType){ //当为HR时
          if("1"==cusSourceType){
            this.$router.push({path: '/index'});
            this.$message.success('登录成功');
          }else{
            let hrUrl = hrCommon.HRCLOUD_URL+"secondMain.action?accessToken="+base64Encode(encrypt(store.getters.accessToken,''));
            console.log(hrUrl);
            window.location.href = hrUrl;
          }
        }else{ //雇员时，跳转到雇员端页面
          let empUrl = hrCommon.HRCLOUD_URL+"emp/index.action?accessToken="+base64Encode(encrypt(store.getters.accessToken,''));
          console.log(empUrl);
          window.location.href = empUrl;
        }
      },
      //忘记密码页面
      handleResetPwd:function(){
        let lang = localStorage.getItem('lang');
        let param = "";
        if(lang){
          param="?lang="+base64Encode(lang)
        }
        var hrcloudPath = hrCommon.HRCLOUD_URL+"accountConfirmation.action"+param;
        window.open(hrcloudPath,"_blank")
      },
      //注册页面
      handleReister:function(){
        let lang = localStorage.getItem('lang');
        let param = "";
        if(lang){
          param="?lang="+base64Encode(lang)
        }
        var hrcloudPath = hrCommon.HRCLOUD_URL+"toRegister.action"+param;
        window.open(hrcloudPath,"_blank")
      },
      // 是否显示code码
      handleIsShowCode() {
        this.changeForm = !this.changeForm
        if (!this.changeForm) {
          produceQrCode().then(res => {
            if (res.data.msg === 'success') {
            this.codeImgSrc = res.data.data
          }
        })
        }

        if (this.changeForm) { return }

        console.log("🚀 ~ file: pwdlogin.vue ~ line 349 ~ handleIsShowCode ~ process.env.VUE_APP_BASE_URL", process.env.VUE_APP_BASE_URL)
        var ws = new WebSocket("ws://2333e85t52.zicp.vip/chartServer/login");

        ws.onopen = (evt) => {
          console.log("Connection open ...");
          ws.send("Hello WebSockets!");
        };

        ws.onmessage = (evt) => {
          ws.close();

          console.log( "Received Message: " + evt.data);
          if (evt.data.code == 0) {
            let params = {
              wxCode: evt.data.wxCode,
              state: evt.data.state
            }
            wcLogin(params).then(res => {

            })

          } else {
            this.$message(evt.data.msg);
            this.changeForm = true
          }
        };

        ws.onclose = function(evt) {
          console.log("Connection closed.");
        };

      },
      getMenus() {
        const menus = [{
          "appId": "ac050c26053f47d1bb8a13299ab8629e",
          "checked": false,
          "code": "EHR_HR_HOME",
          "iconCls": "icon-home",
          "id": "19f2e5f2dbd5f1ed67a623c9a9af4c29",
          "name": "首页",
          "pid": null,
          "url": "aHR0cHM6Ly90ZXN0LWhyLmNpaWNiai5jb20vbWFpbi9pbmRleC5kbw=="
        }, {
          "appId": "ac050c26053f47d1bb8a13299ab8629e",
          "checked": false,
          "code": "EHR_HR_ORG",
          "iconCls": "icon-Administration",
          "id": "3612772915bcaa774248886ba5885a76",
          "name": "组织架构管理",
          "pid": null,
          "url": ""
        }, {
          "appId": "ac050c26053f47d1bb8a13299ab8629e",
          "checked": false,
          "code": "EHR_HR_ENTRY_SERVER_SINGLE",
          "iconCls": "icon-Entry-1",
          "id": "C9AA48C54102DAFFE053D33FA8C0920E",
          "name": "入职服务单",
          "pid": "C9AA48C54101DAFFE053D33FA8C0920E",
          "url": "aHR0cHM6Ly90ZXN0LWhyLmNpaWNiai5jb20vY2lpY3NlcnZlci9lbnRyeV9zZXJ2ZXJfc2luZ2xlX2luZGV4LmRv"
        }, {
          "appId": "ac050c26053f47d1bb8a13299ab8629e",
          "checked": false,
          "code": "EHR_HR_ORG_INS",
          "iconCls": "icon-mechanism",
          "id": "BD3AD20C89F1A59EE053D33FA8C0FBF4",
          "name": "组织机构管理",
          "pid": "3612772915bcaa774248886ba5885a76",
          "url": "aHR0cHM6Ly90ZXN0LWhyLmNpaWNiai5jb20vaHIvc2V0dGluZy9zZXR0aW5nX29yZy5kbw=="
        }, {
          "appId": "ac050c26053f47d1bb8a13299ab8629e",
          "checked": false,
          "code": "EHR_HR_LEAVE_SERVER_SINGLE",
          "iconCls": "icon-Quit-1",
          "id": "C9AA48C54103DAFFE053D33FA8C0920E",
          "name": "离职服务单",
          "pid": "C9AA48C54101DAFFE053D33FA8C0920E",
          "url": "aHR0cHM6Ly90ZXN0LWhyLmNpaWNiai5jb20vY2lpY3NlcnZlci9sZWF2ZV9zZXJ2ZXJfc2luZ2xlX2luZGV4LmRv"
        }, {
          "appId": "ac050c26053f47d1bb8a13299ab8629e",
          "checked": false,
          "code": "EHR_HR_ORG_POST",
          "iconCls": "icon-Personnel-matters-2",
          "id": "BD3AD20C89F2A59EE053D33FA8C0FBF4",
          "name": "人事岗位管理",
          "pid": "3612772915bcaa774248886ba5885a76",
          "url": "aHR0cHM6Ly90ZXN0LWhyLmNpaWNiai5jb20vaHIvc2V0dGluZy9zZXR0aW5nX3Bvc3QuZG8="
        }, {
          "appId": "ac050c26053f47d1bb8a13299ab8629e",
          "checked": false,
          "code": "EHR_HR_ORG_JOBLEVEL",
          "iconCls": "icon-Post-management",
          "id": "BD3AD20C89F3A59EE053D33FA8C0FBF4",
          "name": "职级管理",
          "pid": "3612772915bcaa774248886ba5885a76",
          "url": "aHR0cHM6Ly90ZXN0LWhyLmNpaWNiai5jb20vaHIvc2V0dGluZy9zZXR0aW5nX2pvYl9sZXZlbC5kbw=="
        }, {
          "appId": "ac050c26053f47d1bb8a13299ab8629e",
          "checked": false,
          "code": "EHR_HR_ORG_ESTABLISH",
          "iconCls": "icon-Administration-6",
          "id": "BD3AD20C89F4A59EE053D33FA8C0FBF4",
          "name": "编制管理",
          "pid": "3612772915bcaa774248886ba5885a76",
          "url": "aHR0cHM6Ly90ZXN0LWhyLmNpaWNiai5jb20vb3Jnbml6YXRpb25fbWFuYWdlL2VzdGFibGlzaC9pbmRleC5kbw=="
        }, {
          "appId": "ac050c26053f47d1bb8a13299ab8629e",
          "checked": false,
          "code": "EHR_HR_STAFF",
          "iconCls": "icon-Personnel-matters-1",
          "id": "1b0bf8636d3e96a609dff359b0e51a8b",
          "name": "人事管理",
          "pid": null,
          "url": ""
        }, {
          "appId": "ac050c26053f47d1bb8a13299ab8629e",
          "checked": false,
          "code": "EHR_HR_STAFF_EMPLOYEE",
          "iconCls": "icon-Template-8",
          "id": "BD3AD20C89F5A59EE053D33FA8C0FBF4",
          "name": "员工管理",
          "pid": "1b0bf8636d3e96a609dff359b0e51a8b",
          "url": "aHR0cHM6Ly90ZXN0LWhyLmNpaWNiai5jb20vaHIvZW1wbG95ZWUvZW1wX2luZGV4LmRv"
        }, {
          "appId": "ac050c26053f47d1bb8a13299ab8629e",
          "checked": false,
          "code": "EHR_HR_STAFF_ENTRY",
          "iconCls": "icon-Entry-1",
          "id": "BD3AD20C89F6A59EE053D33FA8C0FBF4",
          "name": "入职办理",
          "pid": "1b0bf8636d3e96a609dff359b0e51a8b",
          "url": "aHR0cHM6Ly90ZXN0LWhyLmNpaWNiai5jb20vaHIvZW1wbG95ZWUvZW1wX2VudHJ5LmRv"
        }, {
          "appId": "ac050c26053f47d1bb8a13299ab8629e",
          "checked": false,
          "code": "EHR_HR_STAFF_TRANSACT",
          "iconCls": "icon-Personnel-matters-1",
          "id": "BD3AD20C89F7A59EE053D33FA8C0FBF4",
          "name": "转正办理",
          "pid": "1b0bf8636d3e96a609dff359b0e51a8b",
          "url": "aHR0cHM6Ly90ZXN0LWhyLmNpaWNiai5jb20vaHIvZW1wbG95ZWUvYmVjb21lX3dvcmtlcl90YWIuZG8="
        }, {
          "appId": "ac050c26053f47d1bb8a13299ab8629e",
          "checked": false,
          "code": "EHR_HR_SERVICE_ORDER",
          "iconCls": "fa fa-file-archive-o",
          "id": "C9AA48C54101DAFFE053D33FA8C0920E",
          "name": "服务单查询",
          "pid": "C9AA48C54100DAFFE053D33FA8C0920E",
          "url": ""
        }, {
          "appId": "ac050c26053f47d1bb8a13299ab8629e",
          "checked": false,
          "code": "EHR_HR_STAFF_CHANGE",
          "iconCls": "icon-Personnel-setup",
          "id": "BD3AD20C89F8A59EE053D33FA8C0FBF4",
          "name": "人事异动",
          "pid": "1b0bf8636d3e96a609dff359b0e51a8b",
          "url": "aHR0cHM6Ly90ZXN0LWhyLmNpaWNiai5jb20vaHIvZW1wL2NoYW5nZS9yZWNvcmQvaW5kZXguZG8="
        }, {
          "appId": "ac050c26053f47d1bb8a13299ab8629e",
          "checked": false,
          "code": "EHR_HR_EMP_SEARCH",
          "iconCls": "fa fa-id-badge",
          "id": "C9AA48C54104DAFFE053D33FA8C0920E",
          "name": "服务员工查询",
          "pid": "C9AA48C54100DAFFE053D33FA8C0920E",
          "url": "aHR0cHM6Ly90ZXN0LWhyLmNpaWNiai5jb20vY2lpY3NlcnZlci9lbXBfc2VhcmNoX2luZGV4LmRv"
        }, {
          "appId": "ac050c26053f47d1bb8a13299ab8629e",
          "checked": false,
          "code": "EHR_HR_SB_ACCOUNT",
          "iconCls": "icon-Post-management",
          "id": "C9AA48C54105DAFFE053D33FA8C0920E",
          "name": "开户管理",
          "pid": "53437150cbe760f87af7235ae2a9b9c1",
          "url": "aHR0cHM6Ly90ZXN0LWhyLmNpaWNiai5jb20vc2lucy9zY2hlbWUvYWNjb3VudF9pbmRleC5kbw=="
        }, {
          "appId": "ac050c26053f47d1bb8a13299ab8629e",
          "checked": false,
          "code": "EHR_HR_STAFF_LEAVE",
          "iconCls": "icon-Quit-1",
          "id": "BD3AD20C89F9A59EE053D33FA8C0FBF4",
          "name": "离职办理",
          "pid": "1b0bf8636d3e96a609dff359b0e51a8b",
          "url": "aHR0cHM6Ly90ZXN0LWhyLmNpaWNiai5jb20vaHIvZW1wbG95ZWUvZW1wX2xlYXZlLmRv"
        }, {
          "appId": "ac050c26053f47d1bb8a13299ab8629e",
          "checked": false,
          "code": "EHR_HR_BILL",
          "iconCls": "icon-Post-management",
          "id": "01baba2d7f0b1315a62958adc76ca997",
          "name": "付款通知单",
          "pid": "C9AA48C54100DAFFE053D33FA8C0920E",
          "url": "aHR0cHM6Ly90ZXN0LWhyLmNpaWNiai5jb20vYmlsbC9pbmRleC5kbw=="
        }, {
          "appId": "ac050c26053f47d1bb8a13299ab8629e",
          "checked": false,
          "code": "EHR_HR_STAFF_DOCUMENT",
          "iconCls": "icon-Material-Science",
          "id": "BD3AD20C89FAA59EE053D33FA8C0FBF4",
          "name": "员工材料",
          "pid": "1b0bf8636d3e96a609dff359b0e51a8b",
          "url": "aHR0cHM6Ly90ZXN0LWhyLmNpaWNiai5jb20vaHIvZW1wbG95ZWUvZW1wX2RvY3VtZW50X21hbmFnZS5kbw=="
        }, {
          "appId": "ac050c26053f47d1bb8a13299ab8629e",
          "checked": false,
          "code": "EHR_HR_STAFF_ARCHIVE",
          "iconCls": "fa fa-file-archive-o",
          "id": "BD3AD20C89FBA59EE053D33FA8C0FBF4",
          "name": "员工人事档案",
          "pid": "C9AA48C54100DAFFE053D33FA8C0920E",
          "url": "aHR0cHM6Ly90ZXN0LWhyLmNpaWNiai5jb20vaHIvZW1wbG95ZWUvZW1wX2FyY2hpdmVfaW5kZXguZG8="
        }, {
          "appId": "ac050c26053f47d1bb8a13299ab8629e",
          "checked": false,
          "code": "EHR_HR_DISPATCH_EMPLOYEE",
          "iconCls": "fa fa-user",
          "id": "C3C45BDDC5865275E053D33FA8C07CFD",
          "name": "派遣员工列表",
          "pid": "C3C45BDDC5855275E053D33FA8C07CFD",
          "url": "aHR0cHM6Ly90ZXN0LWhyLmNpaWNiai5jb20vZGlzcGF0Y2gvZGlzcGF0Y2hfaW5kZXguZG8="
        }, {
          "appId": "ac050c26053f47d1bb8a13299ab8629e",
          "checked": false,
          "code": "EHR_HR_CONTRACT",
          "iconCls": "icon-Post-management",
          "id": "45955e274ecacf7b35b870dac4b23516",
          "name": "劳动用工文本管理",
          "pid": null,
          "url": ""
        }, {
          "appId": "ac050c26053f47d1bb8a13299ab8629e",
          "checked": false,
          "code": "EHR_HR_DISPATCH_HIRE_OFFER",
          "iconCls": "fa fa-file-text-o",
          "id": "C3C45BDDC5875275E053D33FA8C07CFD",
          "name": "聘用通知书",
          "pid": "C3C45BDDC5855275E053D33FA8C07CFD",
          "url": "aHR0cHM6Ly90ZXN0LWhyLmNpaWNiai5jb20vZGlzcGF0Y2gvaGlyZV9pbmRleC5kbw=="
        }, {
          "appId": "ac050c26053f47d1bb8a13299ab8629e",
          "checked": false,
          "code": "EHR_HR_CONTRACT_ADD",
          "iconCls": "icon-Information-import",
          "id": "BD3AD20C89FDA59EE053D33FA8C0FBF4",
          "name": "创建合同",
          "pid": "45955e274ecacf7b35b870dac4b23516",
          "url": "aHR0cHM6Ly90ZXN0LWhyLmNpaWNiai5jb20vY29udHJhY3RjcmVhdG9yL2NvbnRyYWN0X2luZm9fc2VsZWN0d2F5LmRv"
        }, {
          "appId": "ac050c26053f47d1bb8a13299ab8629e",
          "checked": false,
          "code": "EHR_HR_CONTRACT_NORMAL",
          "iconCls": "icon-sign",
          "id": "BD3AD20C89FEA59EE053D33FA8C0FBF4",
          "name": "合同管理",
          "pid": "45955e274ecacf7b35b870dac4b23516",
          "url": "aHR0cHM6Ly90ZXN0LWhyLmNpaWNiai5jb20vY29udHJhY3QvY29udHJhY3RfaW5kZXguZG8="
        }, {
          "appId": "ac050c26053f47d1bb8a13299ab8629e",
          "checked": false,
          "code": "EHR_HR_CONTRACT_IMPORT",
          "iconCls": "icon-Information-import",
          "id": "BD3AD20C89FFA59EE053D33FA8C0FBF4",
          "name": "导入合同",
          "pid": "45955e274ecacf7b35b870dac4b23516",
          "url": "aHR0cHM6Ly90ZXN0LWhyLmNpaWNiai5jb20vY29udHJhY3QvaW1wb3J0X2NvbnRyYWN0X2luZGV4LmRv"
        }, {
          "appId": "ac050c26053f47d1bb8a13299ab8629e",
          "checked": false,
          "code": "EHR_HR_CONTRACT_TEMPLATE",
          "iconCls": "icon-Template-2",
          "id": "BD3AD20C8A00A59EE053D33FA8C0FBF4",
          "name": "合同模板",
          "pid": "45955e274ecacf7b35b870dac4b23516",
          "url": "aHR0cHM6Ly90ZXN0LWhyLmNpaWNiai5jb20vdGVtcGxhdGUvdGVtcGxhdGVfY3VzdG9tZXJfaW5kZXguZG8="
        }, {
          "appId": "ac050c26053f47d1bb8a13299ab8629e",
          "checked": false,
          "code": "EHR_HR_ANALYSIS",
          "iconCls": "icon-Statistics-1",
          "id": "2872f6e04eb394a424d5728329ceece4",
          "name": "人事分析统计",
          "pid": null,
          "url": ""
        }, {
          "appId": "ac050c26053f47d1bb8a13299ab8629e",
          "checked": false,
          "code": "EHR_HR_ANALYSIS_STATIC",
          "iconCls": "icon-Statistics-2",
          "id": "BD3AD20C8A02A59EE053D33FA8C0FBF4",
          "name": "人事分析",
          "pid": "2872f6e04eb394a424d5728329ceece4",
          "url": "aHR0cHM6Ly90ZXN0LWhyLmNpaWNiai5jb20vaHIvc3RhdGljcy9zdGF0aWMuZG8="
        }, {
          "appId": "ac050c26053f47d1bb8a13299ab8629e",
          "checked": false,
          "code": "EHR_HR_CIIC",
          "iconCls": "fa fa-server",
          "id": "C9AA48C54100DAFFE053D33FA8C0920E",
          "name": "中智服务",
          "pid": null,
          "url": ""
        }, {
          "appId": "ac050c26053f47d1bb8a13299ab8629e",
          "checked": false,
          "code": "EHR_HR_ANALYSIS_REPORT",
          "iconCls": "icon-Report-form",
          "id": "BD3AD20C8A03A59EE053D33FA8C0FBF4",
          "name": "人事报表",
          "pid": "2872f6e04eb394a424d5728329ceece4",
          "url": "aHR0cHM6Ly90ZXN0LWhyLmNpaWNiai5jb20vaHIvcmVwb3J0L2luZGV4LmRv"
        }, {
          "appId": "ac050c26053f47d1bb8a13299ab8629e",
          "checked": false,
          "code": "EHR_HR_SYSTEM",
          "iconCls": "icon-Administration-2",
          "id": "53437150cbe760f87af7235ae2a9b9c1",
          "name": "系统管理",
          "pid": null,
          "url": ""
        }, {
          "appId": "ac050c26053f47d1bb8a13299ab8629e",
          "checked": false,
          "code": "EHR_HR_STAFF_SETTING",
          "iconCls": "icon-Personnel-setup",
          "id": "BD3AD20C89FCA59EE053D33FA8C0FBF4",
          "name": "人事设置",
          "pid": "53437150cbe760f87af7235ae2a9b9c1",
          "url": "aHR0cHM6Ly90ZXN0LWhyLmNpaWNiai5jb20vaHIvc2V0dGluZy9pbmRleC5kbw=="
        }, {
          "appId": "ac050c26053f47d1bb8a13299ab8629e",
          "checked": false,
          "code": "EHR_HR_SYSTEM_SETTING",
          "iconCls": "fa-user-circle-o",
          "id": "BD3AD20C8A0EA59EE053D33FA8C0FBF4",
          "name": "系统设定",
          "pid": "53437150cbe760f87af7235ae2a9b9c1",
          "url": "aHR0cHM6Ly90ZXN0LWhyLmNpaWNiai5jb20vc3lzdGVtL2NvbXBhbnkvc2V0dGluZy9pbmRleC5kbw=="
        }, {
          "appId": "ac050c26053f47d1bb8a13299ab8629e",
          "checked": false,
          "code": "EHR_HR_DISPATCH",
          "iconCls": "fa fa-users",
          "id": "C3C45BDDC5855275E053D33FA8C07CFD",
          "name": "派遣员工管理",
          "pid": "C9AA48C54100DAFFE053D33FA8C0920E",
          "url": ""
        }, {
          "appId": "ac050c26053f47d1bb8a13299ab8629e",
          "checked": false,
          "code": "EHR_HR_SYSTEM_USER",
          "iconCls": "icon-Administration-3",
          "id": "BD3AD20C8A0DA59EE053D33FA8C0FBF4",
          "name": "用户管理",
          "pid": "53437150cbe760f87af7235ae2a9b9c1",
          "url": "aHR0cHM6Ly90ZXN0LWhyLmNpaWNiai5jb20vc3lzdGVtL2NvbXBhbnkvbWFuYWdlcl9pbmRleC5kbw=="
        }, {
          "appId": "ac050c26053f46d1bb8a13299ab8631e",
          "checked": false,
          "code": "EHR_SINS_HOME",
          "iconCls": "icon-home",
          "id": "491026bcc3fc1edcfb725d98736ab9f8",
          "name": "首页",
          "pid": null,
          "url": "aHR0cHM6Ly90ZXN0LXNoZWJhby5jaWljYmouY29tL21haW4vaW5kZXguZG8="
        }, {
          "appId": "ac050c26053f46d1bb8a13299ab8631e",
          "checked": false,
          "code": "EHR_SINS_SB_ACCOUNT",
          "iconCls": "icon-Post-management",
          "id": "BE2EF8D31EDCBF3DE053D33FA8C04A08",
          "name": "开户管理",
          "pid": null,
          "url": "aHR0cHM6Ly90ZXN0LXNoZWJhby5jaWljYmouY29tL3NpbnMvc2NoZW1lL2FjY291bnRfaW5kZXguZG8="
        }, {
          "appId": "ac050c26053f46d1bb8a13299ab8631e",
          "checked": false,
          "code": "EHR_SINS_SB",
          "iconCls": "icon-Calculator",
          "id": "20627e0d114cf82e3712db847a3f6aa2",
          "name": "参保管理",
          "pid": null,
          "url": ""
        }, {
          "appId": "ac050c26053f46d1bb8a13299ab8631e",
          "checked": false,
          "code": "EHR_SINS_SB_ADD",
          "iconCls": "icon-Entry-1",
          "id": "BE2EF8D31EDEBF3DE053D33FA8C04A08",
          "name": "报增管理",
          "pid": "20627e0d114cf82e3712db847a3f6aa2",
          "url": "aHR0cHM6Ly90ZXN0LXNoZWJhby5jaWljYmouY29tL3NpbnMvYWRkL2luZGV4LmRv"
        }, {
          "appId": "ac050c26053f46d1bb8a13299ab8631e",
          "checked": false,
          "code": "EHR_SINS_SB_SUB",
          "iconCls": "icon-Quit-1",
          "id": "BE2EF8D31EDFBF3DE053D33FA8C04A08",
          "name": "报减管理",
          "pid": "20627e0d114cf82e3712db847a3f6aa2",
          "url": "aHR0cHM6Ly90ZXN0LXNoZWJhby5jaWljYmouY29tL3NpbnMvc3ViL2luZGV4LmRv"
        }, {
          "appId": "ac050c26053f46d1bb8a13299ab8631e",
          "checked": false,
          "code": "EHR_SINS_CIIC_SUPPLY",
          "iconCls": "fa fa-user-times",
          "id": "C6AAEC0B04754FB9E053D33FA8C0BA91",
          "name": "补缴管理",
          "pid": "20627e0d114cf82e3712db847a3f6aa2",
          "url": "aHR0cHM6Ly90ZXN0LXNoZWJhby5jaWljYmouY29tL3NpbnMvc3VwcGx5L2luZGV4LmRv"
        }, {
          "appId": "ac050c26053f46d1bb8a13299ab8631e",
          "checked": false,
          "code": "EHR_SINS_SB_DEPOSIT",
          "iconCls": "icon-Material-Science",
          "id": "BE2EF8D31EDDBF3DE053D33FA8C04A08",
          "name": "缴存及月报",
          "pid": "20627e0d114cf82e3712db847a3f6aa2",
          "url": "aHR0cHM6Ly90ZXN0LXNoZWJhby5jaWljYmouY29tL3NpbnMvZGVwb3NpdC9pbmRleC5kbw=="
        }, {
          "appId": "ac050c26053f46d1bb8a13299ab8631e",
          "checked": false,
          "code": "EHR_SINS_STATIC",
          "iconCls": "fa-pie-chart",
          "id": "C8CAA93ACA9F0A6FE053D33FA8C02C17",
          "name": "统计分析",
          "pid": null,
          "url": ""
        }, {
          "appId": "ac050c26053f46d1bb8a13299ab8631e",
          "checked": false,
          "code": "EHR_SINS_SB_STATIC",
          "iconCls": "icon-Statistics-2",
          "id": "BE2EF8D31EE1BF3DE053D33FA8C04A08",
          "name": "社保分析",
          "pid": "C8CAA93ACA9F0A6FE053D33FA8C02C17",
          "url": "aHR0cHM6Ly90ZXN0LXNoZWJhby5jaWljYmouY29tL3NpbnMvc3RhdGljcy9pbmRleC5kbw=="
        }, {
          "appId": "ac050c26053f46d1bb8a13299ab8631e",
          "checked": false,
          "code": "EHR_SINS_SB_REPORT",
          "iconCls": "icon-Report-form",
          "id": "BE2EF8D31EE2BF3DE053D33FA8C04A08",
          "name": "社保报表",
          "pid": "C8CAA93ACA9F0A6FE053D33FA8C02C17",
          "url": "aHR0cHM6Ly90ZXN0LXNoZWJhby5jaWljYmouY29tL3NpbnMvcmVwb3J0L25vcm1hbF9pbmRleC5kbw=="
        }, {
          "appId": "ac050c26053f46d1bb8a13299ab8631e",
          "checked": false,
          "code": "EHR_SINS_CIIC_SERVICE",
          "iconCls": "fa fa-hourglass",
          "id": "C5B831C67C3C79A6E053D33FA8C082B2",
          "name": "中智服务",
          "pid": null,
          "url": ""
        }, {
          "appId": "ac050c26053f46d1bb8a13299ab8631e",
          "checked": false,
          "code": "EHR_SINS_CIIC_ADD",
          "iconCls": "icon-Entry-1",
          "id": "C66104DFD1D39296E053D33FA8C0F2FD",
          "name": "报增查询",
          "pid": "C5B831C67C3C79A6E053D33FA8C082B2",
          "url": "aHR0cHM6Ly90ZXN0LXNoZWJhby5jaWljYmouY29tL3NpbnMvY2lpY3N1cHBseS9hZGRfaW5kZXguZG8="
        }, {
          "appId": "ac050c26053f46d1bb8a13299ab8631e",
          "checked": false,
          "code": "EHR_SINS_CIIC_SUB",
          "iconCls": "icon-Quit-1",
          "id": "C66104DFD1D59296E053D33FA8C0F2FD",
          "name": "报减查询",
          "pid": "C5B831C67C3C79A6E053D33FA8C082B2",
          "url": "aHR0cHM6Ly90ZXN0LXNoZWJhby5jaWljYmouY29tL3NpbnMvY2lpY3N1cHBseS9zdWJfaW5kZXguZG8="
        }, {
          "appId": "ac050c26053f46d1bb8a13299ab8631e",
          "checked": false,
          "code": "EHR_SINS_CIIC_SUPPLY",
          "iconCls": "fa fa-user-times",
          "id": "C66104DFD1D79296E053D33FA8C0F2FD",
          "name": "补缴查询",
          "pid": "C5B831C67C3C79A6E053D33FA8C082B2",
          "url": "aHR0cHM6Ly90ZXN0LXNoZWJhby5jaWljYmouY29tL3NpbnMvY2lpY3N1cHBseS9zdXBwbHlfaW5kZXguZG8="
        }, {
          "appId": "ac050c26053f46d1bb8a13299ab8631e",
          "checked": false,
          "code": "EHR_SINS_CIIC_MONTH",
          "iconCls": "icon-Material-Science",
          "id": "C66104DFD1D99296E053D33FA8C0F2FD",
          "name": "缴存及月报",
          "pid": "C5B831C67C3C79A6E053D33FA8C082B2",
          "url": "aHR0cHM6Ly90ZXN0LXNoZWJhby5jaWljYmouY29tL3NpbnMvY2lpY3N1cHBseS9tb250aF9pbmRleC5kbw=="
        }, {
          "appId": "ac050c26053f46d1bb8a13299ab8631e",
          "checked": false,
          "code": "EHR_SINS_SB_COLLECT",
          "iconCls": "fa fa-database",
          "id": "BE2EF8D31EE0BF3DE053D33FA8C04A08",
          "name": "基数采集",
          "pid": "C5B831C67C3C79A6E053D33FA8C082B2",
          "url": "aHR0cHM6Ly90ZXN0LXNoZWJhby5jaWljYmouY29tL3NpbnMvYmFzZS9hZGp1c3QvaW5kZXguZG8="
        }, {
          "appId": "ac050c26053f46d1bb8a13299ab8631e",
          "checked": false,
          "code": "EHR_SINS_SYSTEM",
          "iconCls": "icon-Administration-2",
          "id": "e3c7c9f78b1bc48e109babc7ffc9325a",
          "name": "系统管理",
          "pid": null,
          "url": ""
        }, {
          "appId": "ac050c26053f46d1bb8a13299ab8631e",
          "checked": false,
          "code": "EHR_SINS_SYSTEM_SETTING",
          "iconCls": "fa-user-circle-o",
          "id": "BE2EF8D31EE5BF3DE053D33FA8C04A08",
          "name": "系统设定",
          "pid": "e3c7c9f78b1bc48e109babc7ffc9325a",
          "url": "aHR0cHM6Ly90ZXN0LXNoZWJhby5jaWljYmouY29tL3N5c3RlbS9jb21wYW55L3NldHRpbmcvaW5kZXguZG8="
        }, {
          "appId": "ac050c26053f46d1bb8a13299ab8631e",
          "checked": false,
          "code": "EHR_SINS_SYSTEM_USERMANAGEMENT",
          "iconCls": "icon-Administration-3",
          "id": "BE2EF8D31EE4BF3DE053D33FA8C04A08",
          "name": "用户管理",
          "pid": "e3c7c9f78b1bc48e109babc7ffc9325a",
          "url": "aHR0cHM6Ly90ZXN0LXNoZWJhby5jaWljYmouY29tL3N5c3RlbS9jb21wYW55L21hbmFnZXJfaW5kZXguZG8="
        }]
        return dataToTree(menus)
      }
    }
  };
</script>

<style lang="scss" scoped>
  .pwd-login {
  .el-button {
    font-size: 0.24rem;
  }

  /**header */
  .h-font {
    width: 100%;
  span {
    display: block;
    font-size: 0.26rem;
    text-align: left;
  }
  span:first-child {
    text-align: right;
    margin: 0.10rem 0.10rem 0 0;
    cursor: pointer;
  img {
    display: inline-block;
    width: 0.49rem;
    height: 0.50rem;
  }
  }
  span:last-child {
    margin-top: -0.30rem;
    margin-left: 0.34rem;
    margin-bottom: 0.42rem;
    font-weight: 600;
    color: #333333;
  }

  }

  .login-form {
    padding: 0 0.34rem;
  }

  /** 下拉多选 */
  &::v-deep .el-select .el-input__inner {
     height: 0.6rem;
     border-radius: 0.44rem;
     border: 1px solid rgba(57, 63, 108, 0.59);
     font-size: 0.24rem;
     font-weight: 400;
   }

  /**用户密码 */
  .item-user-password {
    width: 4.43rem;
    margin: 0 auto;
    margin-bottom: 0.30rem;
  .span-box {
    display: inline-block;
    font-size: 0.24rem;
    color: #999999;
    margin-bottom: 0.12rem;
  .label-img-icon {
    display: inline-block;
    width: 0.20rem;
    margin-top: -0.02rem;
    vertical-align: middle;
  }
  }
  &::v-deep .el-input--medium .el-input__inner {
     height: 0.60rem;
     border-radius: 0.44rem;
     border: 1px solid rgba(57, 63, 108, 0.59);
   }
  }

  /** 按钮 */
  .login-button-item {
    width: 100%;
    text-align: center;
  &::v-deep .el-button--medium{
     width: 1.91rem;
     height: 0.60rem;
     background: #393F6C;
     border-radius: 0.44rem;
     border: none;
   }
  }

  /** 验证码 */
  .item-code {
    margin-top: -0.10rem;
  &::v-deep .el-input--medium {width: 2.45rem;}
  &::v-deep .el-input--medium .el-input__inner {
     height: 0.60rem;
     border-radius: 0.44rem;
     border: 1px solid rgba(57, 63, 108, 0.59);
     font-size: 0.24rem;
     font-weight: 400;
     text-align: center;
   }
  &::v-deep .el-image {
     width: 1.48rem;
     height: 0.46rem;
     float: right;
     margin-top: 0.07rem;
   }
  }

  /**en 注册 忘记密码 */
  .forgetItem {
    margin-bottom: 0.11rem;
    display: flex;
    justify-content: space-between;
  &::v-deep .el-link.el-link--primary{
     font-size: 0.18rem;
     color: #014897;
     text-decoration:underline
   }
  }

  &::v-deep .icon,.login-form .el-input__icon{
     color: rgba(1, 72, 151, 0.5);
   }


  // 二维码图片
     .cui-s-code {
       text-align: center;
  padding: 0 0.30rem
                 img {
                   display: inline-block;
                 // width: 100%;
                 }
  }
  }

</style>
